import { api } from '@services/apiService';

export type AdminSearchResult =
  | { type: 'team'; uuid: string; name: string }
  | {
      type: 'app';
      uuid: string;
      name: string;
      teamUuid: string;
      teamName: string;
    }
  | { type: 'user'; id: number; name: string | null; email: string };

export async function searchResources(query: string) {
  const searchParams = new URLSearchParams();
  searchParams.append('query', query);

  return await api
    .get('admin/search', { searchParams })
    .json<{ results: AdminSearchResult[] }>();
}
